var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"light-theme",attrs:{"id":"app"}},[(_vm.routerAlive)?_c('Layout',[_c('router-view')],1):_vm._e(),_c('UploadScheduler')],1)}
var staticRenderFns = []

export { render, staticRenderFns }